import React from 'react';

// DEPENDENCIES
import toString from 'lodash/toString';
import { useFormikContext } from 'formik';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';
import Card from 'parts/card/Card';

// LOCAL COMPONENTS
import EmployeeCounts from './parts/EmployeeCounts';

// RENDER
const EmployeeInfoForm = () => {
  const { values } = useFormikContext() || {};

  const {
    am_days_diff_between_sales_update,
    fm_days_diff_between_sales_update,
    number_of_times_am_manager_updated,
    number_of_times_fm_manager_updated,
    number_of_times_sales_manager_1_updated,
    number_of_times_sales_manager_2_updated,
    number_of_times_sales_person_1_updated,
    number_of_times_sales_person_2_updated,
    sales_manager_1_days_diff_between_sales_update,
    sales_manager_2_days_diff_between_sales_update,
    sales_person_1_days_diff_between_sales_update,
    sales_person_2_days_diff_between_sales_update,
    salesman2,
    salesmanager2,
    am_assignment_user_full_name,
    fm_assignment_user_full_name
  } = values || {};

  return (
    <Form.Body>
      <Form.PlainText
        name="salesman1"
        label="Salesperson 1"
        input={{
          append: (
            <EmployeeCounts
              changes={number_of_times_sales_person_1_updated}
              days={sales_person_1_days_diff_between_sales_update}
            />
          )
        }}
      />
      {!!toString(salesman2).trim() && (
        <Form.PlainText
          name="salesman2"
          label="Salesperson 2"
          input={{
            append: (
              <EmployeeCounts
                changes={number_of_times_sales_person_2_updated}
                days={sales_person_2_days_diff_between_sales_update}
              />
            )
          }}
        />
      )}
      <Form.PlainText
        name="salesmanager1"
        label="Sales Manager 1"
        input={{
          append: (
            <EmployeeCounts
              changes={number_of_times_sales_manager_1_updated}
              days={sales_manager_1_days_diff_between_sales_update}
            />
          )
        }}
      />
      {!!toString(salesmanager2).trim() && (
        <Form.PlainText
          name="salesmanager2"
          label="Sales Manager 2"
          input={{
            append: (
              <EmployeeCounts
                changes={number_of_times_sales_manager_2_updated}
                days={sales_manager_2_days_diff_between_sales_update}
              />
            )
          }}
        />
      )}
      {!!toString(am_assignment_user_full_name).trim() && (
        <Form.PlainText
          name="am_assignment_user_full_name"
          label="AM Manager"
          input={{
            append: (
              <EmployeeCounts changes={number_of_times_am_manager_updated} days={am_days_diff_between_sales_update} />
            )
          }}
        />
      )}
      {!!toString(fm_assignment_user_full_name).trim() && (
        <Form.PlainText
          name="fm_assignment_user_full_name"
          label="F&amp;I Manager"
          input={{
            append: (
              <EmployeeCounts changes={number_of_times_fm_manager_updated} days={fm_days_diff_between_sales_update} />
            )
          }}
        />
      )}
    </Form.Body>
  );
};

export default function EmployeeInfo(props) {
  return <Card title="Employee Info" body={<EmployeeInfoForm {...props} />} />;
}
